import { render } from "./ScrollTriggerNr2.vue?vue&type=template&id=2bc42ccc&scoped=true"
import script from "./ScrollTriggerNr2.vue?vue&type=script&lang=js"
export * from "./ScrollTriggerNr2.vue?vue&type=script&lang=js"

import "./ScrollTriggerNr2.vue?vue&type=style&index=0&id=2bc42ccc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc42ccc"]])

export default __exports__